export default {
      id: "icon_ajhg-usage",
      viewBox: "0 0 46 17",
      url: __webpack_public_path__ + "sprite.svg#icon_ajhg",
      toString: function () {
        return this.url;
      }
    }